import React from 'react';

import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';
import Color from 'color';
import { useHistory, useLocation } from 'react-router-dom';

const useStyles = makeMuiStyles((theme, common) => ({
  button: {
    ...common.baseButton,
    ...common.flexInline,
    ...common.middleText,
    padding: '0 30px',
    alignItems: 'center',
    fontWeight: 600,
    width: '100%',
    maxWidth: 360,
    minWidth: 120,
    borderRadius: 4,
    '&$selected': {
      backgroundColor: Color(theme.palette.primary.main).alpha(0.1).toString(),
    },
    justifyContent: 'flex-start',
    height: 52,
    [theme.breakpoints.down('sm')]: {
      ...common.flexColumnCenter,
      ...common.bigText,
      fontWeight: 600,
      padding: '10px 5px',
      width: '30%',
      flex: '1 1 1',
      minWidth: 80,
    },
  },
  selected: {},
  container: {
    ...common.flexColumn,
    paddingRight: '1rem',
    borderRight: '1px solid #EEEEEE',
    minWidth: 242,
    [theme.breakpoints.down('sm')]: {
      ...common.flexInline,
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      gap: 5,
      paddingRight: 0,
      borderRight: 'none',
    },
  },
}));

export interface NavigationButtonProps {
  text: React.ReactNode;
  icon: React.ReactNode;
  selected?: boolean;
  onClick: () => void;
}

export const NavigationButton: React.FC<NavigationButtonProps> = (props) => {
  const { text, icon, selected, onClick } = props;

  const classes = {
    ...useStyles(),
  };

  return (
    <button className={clsx(classes.button, selected && classes.selected)} onClick={onClick}>
      {icon}
      <div style={{ width: 12 }} />
      {text}
    </button>
  );
};

export interface NavigationRoute {
  name: string;
  label: string;
  icon: React.ReactNode;
}

export interface NavigationProps {
  baseUrl: string;
  routes: NavigationRoute[];
}

export const Navigation: React.FC<NavigationProps> = (props) => {
  const location = useLocation();
  const { baseUrl, routes } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const history = useHistory();

  return (
    <div className={classes.container}>
      {routes.map((route) => (
        <NavigationButton
          selected={`${baseUrl}/${route.name}` === location.pathname}
          key={route.name}
          text={route.label}
          icon={route.icon}
          onClick={() => history.push(`${baseUrl}/${route.name}`)}
        />
      ))}
    </div>
  );
};
